module.exports = __webpack_public_path__ + "img/appD.0e286695.svg";